import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CaseListPayload,
  CaseStatusesPayload,
  CaseClosedReasonsPayload,
  CaseResource,
  CaseStatusTransitionResource,
  CreateCaseRequest,
  DomainResource,
  ObjectiveTypeResource,
  QueryCasesRequest,
  TransitionCaseStatusRequest,
  UpdateCaseRequest,
} from './case-api.model';

export interface CaseApi {
  listCaseStatuses(): Observable<CaseStatusesPayload>;
  listCaseClosedReasons(): Observable<CaseClosedReasonsPayload>;
  createCase(body: CreateCaseRequest): Observable<CaseResource>;
  updateCase(caseId: number, body: UpdateCaseRequest): Observable<CaseResource>;
  getCase(caseId: number): Observable<CaseResource>;
  queryCases(body: QueryCasesRequest): Observable<CaseListPayload>;
  listDomains(): Observable<DomainResource[]>;
  listObjectiveTypes(domainId: number): Observable<ObjectiveTypeResource[]>;
  transitionCaseStatus(
    caseId: number,
    body: TransitionCaseStatusRequest,
  ): Observable<CaseStatusTransitionResource>;
}

export const CASE_API = new InjectionToken<CaseApi>('CASE_API');
